import { useEffect, useState } from 'react';
import { useIsSegmentLoaded } from './useIsSegmentLoaded';

const useSegmentId = () => {
  const isSegmentLoaded = useIsSegmentLoaded();
  const [segmentId, setSegmentId] = useState<string>(null);

  useEffect(() => {
    if (!isSegmentLoaded) return;
    window.analytics.ready(() => {
      try {
        setSegmentId(window.analytics.user().anonymousId());
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Encountered fatal error retrieving Segment ID', error);
      }
    });
  }, [isSegmentLoaded]);

  return segmentId;
};

export default useSegmentId;
